/// <reference path="./constants.ts"/>
/// <reference path="./state-objects.ts"/>
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedClient = void 0;
var constants_1 = require("./constants");
var state_objects_1 = require("./state-objects");
// Event emitter to notify the host application about embed events from portal
var events = require('events');
require('es6-promise/auto');
/**
 * Embed Client Helper
 */
var EmbedClient = /** @class */ (function () {
    function EmbedClient(rootElement, options) {
        var _this_1 = this;
        this._disconnectingSession = false;
        this._waiting_for_new_ie_frame = false;
        this._isBridgeReady = false;
        this.reportError = function (error) {
            var embedError;
            if (error.errorMessage !== null && error.errorCode !== null
                && error.errorMessage !== undefined && error.errorCode !== undefined) {
                embedError = error;
            }
            else {
                embedError = {
                    errorCode: 500,
                    errorMessage: constants_1.EmbedConstants.ErrorMessages.INTERNAL_SERVER_ERROR
                };
            }
            _this_1._eventEmitter.emit(constants_1.EmbedConstants.Events.EVENT_SESSION_ERROR, embedError);
        };
        this._isIE_or_Edge = function () {
            return (window.navigator.userAgent.indexOf("MSIE") > 0 || window.navigator.userAgent.indexOf("Trident") > 0 || window.navigator.userAgent.indexOf("Edge") > 0);
        };
        this._bridgeReady = function (event) {
            var _a;
            _this_1._isBridgeReady = true;
            _this_1._eventEmitter.emit(constants_1.EmbedConstants.Events.EVENT_API_BRIDGE, (_a = {}, _a[constants_1.EmbedConstants.Events.EVENT_PARAM_STATUS] = 'success', _a));
            // Add listeners for fullscreen sdk support
            _this_1.addFullscreenEventListeners();
        };
        this._bridgeError = function (event) {
            _this_1._waiting_for_new_ie_frame = false;
            var embedError = {
                errorCode: 500,
                errorMessage: constants_1.EmbedConstants.ErrorMessages.INTERNAL_SERVER_ERROR
            };
            _this_1.reportError(embedError);
        };
        /**
         * Updates the user interface state object from message payload & emits event
         * @param newUserInterfaceState
         */
        this.updateUserInterfaceState = function (newUserInterfaceState) {
            if (!_this_1._userInterfaceState) {
                _this_1._userInterfaceState = new state_objects_1.EmbedState.EmbedUserInterfaceState;
            }
            _this_1._eventEmitter.emit(constants_1.EmbedConstants.Events.EVENT_USER_INTERFACE_STATE_CHANGED, _this_1._userInterfaceState.updateState(newUserInterfaceState));
        };
        /**
         * Updates the seession state object from message payload & emits event
         * @param newSessionState
         */
        this.updateSessionState = function (newSessionState) {
            if (!_this_1._sessionState) {
                _this_1._sessionState = new state_objects_1.EmbedState.EmbedSessionState();
            }
            _this_1._eventEmitter.emit(constants_1.EmbedConstants.Events.EVENT_SESSION_STATE_CHANGED, _this_1._sessionState.updateState(newSessionState));
            if (newSessionState.sessionStatus == constants_1.EmbedConstants.SessionStatus.Disconnected && _this_1._disconnectingSession) {
                _this_1.destroy();
            }
        };
        /**
         * Emits EVENT_SPINNER event with spinner state data from message payload
         * @param spinnerState
         */
        this.updateSpinnerState = function (spinner) {
            _this_1._eventEmitter.emit(constants_1.EmbedConstants.Events.EVENT_SPINNER, spinner);
        };
        this.copyFromRemote = function (clipboardText) {
            if (clipboardText) {
                var copyFromRemoteEvent = {
                    clipboardText: clipboardText
                };
                _this_1._eventEmitter.emit(constants_1.EmbedConstants.Events.EVENT_COPY_FROM_REMOTE, copyFromRemoteEvent);
            }
        };
        this.isValidFileUrl = function (downloadUrl) {
            var pattern = new RegExp(constants_1.EmbedConstants.FILE_DOWNLOAD_URL_REGEX);
            return downloadUrl && pattern.test(downloadUrl);
        };
        this.handleDownloadFileEvent = function (event) {
            if (event && _this_1.isValidFileUrl(event.url)) {
                _this_1._eventEmitter.emit(constants_1.EmbedConstants.Events.EVENT_FILE_DOWNLOAD_READY, event);
            }
        };
        this._options = this.sanitize(options);
        this._eventEmitter = new events.EventEmitter();
        if (this._options) {
            this._onBridgeReady = this._getBridgeReady(rootElement);
            var frame = this._createSessionIframe(this._options);
            if (this._isIE_or_Edge()) {
                frame.style.display = "none";
            }
            this._iframe = frame;
            this._iframe.onload = function () {
                this._clientOrigin = this._urlOrigin(this._iframe.src);
            }.bind(this);
            rootElement.appendChild(this._iframe);
            this._client = this._iframe.contentWindow;
            this._clientOrigin = this._urlOrigin(this._options.sessionURL);
            this._origin = document.location.origin;
        }
    }
    EmbedClient.prototype.sanitize = function (options) {
        var embedError;
        if (!options.sessionURL) {
            console.error("Expected AppStream streaming URL to embed.");
            embedError = {
                errorCode: 400,
                errorMessage: constants_1.EmbedConstants.ErrorMessages.MISSING_PARAMETER
            };
            this.reportError(embedError);
        }
        if (options.userInterfaceConfig) {
            if (options.userInterfaceConfig.hiddenElements) {
                if (options.userInterfaceConfig.hiddenElements.length > constants_1.EmbedConstants.MAX_HIDDEN_ELEMENTS_LENGTH) {
                    embedError = {
                        errorCode: 400,
                        errorMessage: constants_1.EmbedConstants.ErrorMessages.VALIDATION_ERROR
                    };
                    console.error("Exceeded the number of hidden elements allowed : " + constants_1.EmbedConstants.MAX_HIDDEN_ELEMENTS_LENGTH);
                    this.reportError(embedError);
                }
                if (!Array.isArray(options.userInterfaceConfig.hiddenElements)) {
                    embedError = {
                        errorCode: 400,
                        errorMessage: constants_1.EmbedConstants.ErrorMessages.VALIDATION_ERROR
                    };
                    console.error("Hidden elements must be of type Array");
                    this.reportError(embedError);
                }
            }
            if (options.userInterfaceConfig.disabledInput) {
                if (!Array.isArray(options.userInterfaceConfig.disabledInput)) {
                    embedError = {
                        errorCode: 400,
                        errorMessage: constants_1.EmbedConstants.ErrorMessages.VALIDATION_ERROR
                    };
                    console.error("Disabled input must be of type Array");
                    this.reportError(embedError);
                }
            }
        }
        return options;
    };
    EmbedClient.prototype.serializeKeyboardEvent = function (kbEvent) {
        if (kbEvent !== null && kbEvent !== undefined && kbEvent instanceof KeyboardEvent) {
            var serializedEvent = {
                type: kbEvent.type,
                eventInit: {
                    key: kbEvent.key,
                    location: kbEvent.location,
                    ctrlKey: kbEvent.ctrlKey,
                    altKey: kbEvent.altKey,
                    shiftKey: kbEvent.shiftKey,
                    metaKey: kbEvent.metaKey,
                    code: kbEvent.code,
                    repeat: kbEvent.repeat,
                }
            };
            return serializedEvent;
        }
        return null;
    };
    /**
     * State accessors - returns copy of internal state objects
     */
    EmbedClient.prototype._getSessionState = function () {
        if (!this._sessionState)
            return null;
        var sessionStateObject = {};
        if (this._sessionState.sessionStatus !== null && this._sessionState.sessionStatus !== undefined) {
            sessionStateObject[state_objects_1.EmbedState.EmbedSessionState.SESSION_STATUS_KEY] = this._sessionState.sessionStatus;
        }
        if (this._sessionState.sessionTerminationReason !== null && this._sessionState.sessionTerminationReason !== undefined) {
            sessionStateObject[state_objects_1.EmbedState.EmbedSessionState.SESSION_TERMINATION_REASON_KEY] = this._sessionState.sessionTerminationReason;
        }
        if (this._sessionState.sessionDisconnectionReason !== null && this._sessionState.sessionDisconnectionReason !== undefined) {
            sessionStateObject[state_objects_1.EmbedState.EmbedSessionState.SESSION_DISCONNECTION_REASON_KEY] = this._sessionState.sessionDisconnectionReason;
        }
        return sessionStateObject;
    };
    EmbedClient.prototype._getUserInterfaceState = function () {
        if (!this._userInterfaceState)
            return null;
        return {
            hidden: this._userInterfaceState.hidden,
            isFullscreen: this._userInterfaceState.isFullscreen,
            isSoftKeyboardVisible: this._userInterfaceState.isSoftKeyboardVisible,
            isCopyAllowed: this._userInterfaceState.isCopyAllowed,
            isPasteAllowed: this._userInterfaceState.isPasteAllowed,
            isFileUploadAllowed: this._userInterfaceState.isFileUploadAllowed,
            isFileDownloadAllowed: this._userInterfaceState.isFileDownloadAllowed
        };
    };
    /**
     *
     * @param method
     * @param args
     */
    EmbedClient.prototype.callSessionMethod = function (method, args) {
        this._sendMessage(method, args);
    };
    /**
      * To avoid destroying the frame before AppStream has a chance to disconnect the DCV connection, the approach here is to:
      *    (1) Tell embed-service.ts we're going to destroy the iFrame.
      *    (2) embed-service.ts tells DCV AppStream session will be disconnecting.
      *    (3) Destroy iFrame in min(x, EmbedConstants.DISCONNECT_WAIT_TIMEOUT) where x = time it takes for (2) to complete and let embed-helper know.
     */
    EmbedClient.prototype.disconnect = function () {
        var _this_1 = this;
        this._disconnectingSession = true;
        this._sendMessage(constants_1.EmbedConstants.METHOD_DISCONNECT_SESSION);
        setTimeout(function () { return _this_1.destroy(); }, constants_1.EmbedConstants.DISCONNECT_WAIT_TIMEOUT);
    };
    EmbedClient.prototype.destroy = function () {
        this._iframe.parentNode.removeChild(this._iframe);
        this._waiting_for_new_ie_frame = false;
        window.removeEventListener('message', this);
        delete this._iframe;
        delete this._client;
    };
    /******************
     * PRIVATE METHODS
     */
    EmbedClient.prototype._createSessionIframe = function (options) {
        var iframe = document.createElement('iframe');
        // Default
        iframe.setAttribute('frameBorder', '0');
        // Set attributes from config
        if (options.iframeConfig !== undefined && options.iframeConfig !== null) {
            this.setElementAttributes(iframe, options.iframeConfig);
        }
        // not overridable attrs
        iframe.setAttribute('src', options.sessionURL);
        iframe.setAttribute('id', 'appstream-streaming-session');
        iframe.setAttribute('allow', 'fullscreen *; microphone *; clipboard-write *; clipboard-read *; camera *;');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('scrolling', 'no');
        // Required due to IOS iframe resizing issues: https://stackoverflow.com/questions/23083462/how-to-get-an-iframe-to-be-responsive-in-ios-safari/23083463#23083463
        iframe.style.height = "1px";
        iframe.style.width = "1px";
        iframe.style.minHeight = "100%";
        iframe.style.minWidth = "100%";
        return iframe;
    };
    EmbedClient.prototype.setElementAttributes = function (el, attrs) {
        if (el !== null && el !== undefined && el instanceof HTMLElement) {
            for (var key in attrs) {
                if (key.length > 0 && attrs[key] !== null && attrs[key] !== undefined) {
                    el.setAttribute(key, attrs[key]);
                }
            }
        }
    };
    /******************
     * Post Message Bridge Functions
     */
    /**
     * The Bridge is the communication channel between the host application JS and the Portal JS.
     * This function adds a message listener and a time out waiting for the portal to send a message
     * saying that it is ready. Once that message is received here we remove the original event listener
     * and add the eventHandler function to process messages
     *
     * Flow:
     * (a) embed-service.ts calls _sendBridgeReady()
     * (b) embed-helper.ts listens to (a), waitAPIReady, sends embed options.
     * (c) embed-service.ts _waitsEmbedOptions handles (b) and binds other event listeners.
     * (d) embed-service.ts sends initialStateUpdate to embed-helper.ts
     * (e) embed-helper.ts listens to (d), waitInitialState, and binds other event listeners.
     *  Handshake is completed.
     */
    EmbedClient.prototype._getBridgeReady = function (rootElement) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var listenForAPIReady;
            if (_this._isIE_or_Edge()) {
                listenForAPIReady = waitAPIReadyIE.bind(_this);
            }
            else {
                listenForAPIReady = waitAPIReady.bind(_this);
            }
            var listenForInitialState = waitInitialState.bind(_this);
            window.addEventListener('message', listenForAPIReady);
            // 60 second timeout for bridge to be established
            setTimeout(reject, constants_1.EmbedConstants.HOST_WAIT_TIMEOUT);
            // Once we receive embedOptions from embed-service.ts, we add an event listener to receive initial state objects.
            function waitAPIReady(message) {
                if (_this._isClientMessage(message) && message.data.method === constants_1.EmbedConstants.METHOD_EMBED_CLIENT_INTERFACE_READY) {
                    var argsV1 = message.data.args[0];
                    var redir = argsV1.embedOrigin;
                    if (redir !== null && redir !== undefined) {
                        _this._clientOrigin = redir;
                        _this._iframe.setAttribute('allow', 'fullscreen ' + _this._clientOrigin + '; microphone ' + _this._clientOrigin + '; clipboard-read ' + _this._clientOrigin + '; clipboard-write ' + _this._clientOrigin + '; camera ' + _this._clientOrigin);
                    }
                    window.addEventListener('message', listenForInitialState);
                    _this._sendEmbedOptions();
                }
            }
            /** This method was created because the multisession functionality of portal breaks the IE embedding experience.
             * When the portal logic does a server-side redirect to a multi session subdomain, IE starts blocking certain calls
             * because the iframe src doesn't match the location. To resolve this we grab the subdomain url, destroy the original
             * iframe, and create a new iframe with the subdomain as the src.
             *
             * */
            function waitAPIReadyIE(message) {
                if (_this._isClientMessage(message) && message.data.method === constants_1.EmbedConstants.METHOD_EMBED_CLIENT_INTERFACE_READY) {
                    try {
                        var client = _this._clientOrigin.split("https://")[1].split(":")[0];
                        var argsV1 = message.data.args[0];
                        if (!_this._waiting_for_new_ie_frame && argsV1.embedOrigin.indexOf(client) > -1) {
                            _this._clientOrigin = argsV1.embedOrigin;
                            var authParams = _this._options.sessionURL.split("/authenticate?")[1];
                            var subdomainAuth_1 = _this._clientOrigin + "/authenticate?" + authParams;
                            _this._options.sessionURL = subdomainAuth_1;
                            if (argsV1.recreateIFrame == true) {
                                _this.destroy();
                                _this._iframe = _this._createSessionIframe(_this._options);
                                _this._iframe.onload =
                                    function () {
                                        _this._clientOrigin = _this._urlOrigin(subdomainAuth_1);
                                    }.bind(_this);
                                rootElement.appendChild(_this._iframe);
                                _this._client = _this._iframe.contentWindow;
                                _this._clientOrigin = _this._urlOrigin(_this._options.sessionURL);
                                _this._origin = document.location.origin;
                                _this._waiting_for_new_ie_frame = true;
                            }
                        }
                        else {
                            window.addEventListener('message', listenForInitialState);
                            _this._sendEmbedOptions();
                            _this._waiting_for_new_ie_frame = false;
                        }
                    }
                    catch (e) {
                        var embedError = {
                            errorCode: 500,
                            errorMessage: constants_1.EmbedConstants.ErrorMessages.INTERNAL_SERVER_ERROR
                        };
                        console.error("Error during the IE/Edge Specific multi session flow");
                        console.error(e);
                        _this.reportError(embedError);
                    }
                }
            }
            // Once we receive initial state objects, then we can start handling other events (refer to handleEvent())
            function waitInitialState(message) {
                if (_this._isClientMessage(message) && message.data.method === constants_1.EmbedConstants.METHOD_SEND_INITIAL_STATE) {
                    window.removeEventListener('message', listenForInitialState);
                    window.addEventListener('message', _this);
                    var argsV1 = message.data.args[0];
                    _this.updateUserInterfaceState(argsV1.userInterfaceState);
                    _this.updateSessionState(argsV1.sessionState);
                    resolve(null);
                }
            }
        }).then(_this._bridgeReady, _this._bridgeError);
    };
    /**
     * Sends the embed options
     */
    EmbedClient.prototype._sendEmbedOptions = function () {
        var embedOptions = {
            origin: this._origin,
            sessionURL: this._options.sessionURL,
            clientVersion: constants_1.EmbedConstants.ClientVersions.V1,
            userInterfaceConfig: this._options.userInterfaceConfig
        };
        var argsV1 = {
            embedOptions: embedOptions
        };
        this._sendMessage(constants_1.EmbedConstants.METHOD_EMBED_OPTIONS, argsV1);
    };
    /**
     * Remove non uppercase and lowercase Latin letters, digits, and underscores from string
     */
    EmbedClient.prototype._sanitize = function (field) {
        return typeof field === 'string' ? field.replace(/[^\w]/g, '') : '';
    };
    /**
     * Sends a message to web app
     * @param {*} method
     * @param {Interfaces.ArgsV1} argsV1
     * @param {string} messageVersion
     */
    EmbedClient.prototype._sendMessage = function (method, argsV1, messageVersion) {
        if (messageVersion === void 0) { messageVersion = constants_1.EmbedConstants.MessageVersions.V1; }
        // Set the namespace so only servers can read this message.
        // This prevents us from accidentally talking to ourselves.
        var payload = {
            namespace: constants_1.EmbedConstants.BRIDGE_HOST_NAMESPACE,
            messageVersion: messageVersion,
            method: method,
            args: [argsV1],
        };
        this._client.postMessage(payload, this._clientOrigin);
    };
    /**
     * Validate and pre-process message arguments
     * @param action
     * @param {Interfaces.ArgsV1} args
     */
    EmbedClient.prototype._validateMessageArgs = function (action, args) {
        var _this_1 = this;
        return new Promise(function (resolve, reject) {
            var sanitizedAction = _this_1._sanitize(action);
            var methodVersion = _this_1._getMethodVersion(sanitizedAction);
            if (methodVersion === null) {
                reject("Action provided is not valid.");
                return;
            }
            else if (args === null) {
                resolve([methodVersion, sanitizedAction, {}]);
                return;
            }
            else {
                var parameterFieldTypes = {
                    string: new Set(['remotePath', 'newPath', 'clipboardText', 'screenResolution', 'streamingMode']),
                    boolean: new Set(['microphoneEnabled', 'webcamEnabled', 'spinnerVisible', 'useOptionAsAltKey', 'useCommandAsControlKey']),
                    object: new Set(['keyboardEvent', 'keys'])
                };
                for (var prop in args) {
                    if (Object.prototype.hasOwnProperty.call(args, prop)) {
                        for (var _i = 0, _a = Object.entries(parameterFieldTypes); _i < _a.length; _i++) {
                            var _b = _a[_i], fieldType = _b[0], fieldNames = _b[1];
                            if (fieldNames.has(prop)) {
                                if (typeof args[prop] !== fieldType) {
                                    reject("Argument \"".concat(prop, "\" is not a valid ").concat(fieldType));
                                    return;
                                }
                            }
                        }
                    }
                }
                // If a file parameter is passed we need to perform an async operation
                if (args.file === undefined) {
                    resolve([methodVersion, sanitizedAction, args]);
                    return;
                }
                else {
                    // Pre-fetching array buffer from file before postMessage.
                    // Passing the file using postMessage truncates all logic/functions
                    // which breaks fetching file data on the receiving end.
                    // If this is not done file upload will fail.
                    var reader_1 = new FileReader();
                    var file_1 = args.file;
                    reader_1.onload = function () {
                        var arrayBuff = reader_1.result;
                        args.file = new File([arrayBuff], file_1.name, {
                            type: file_1.type,
                            lastModified: file_1.lastModified,
                        });
                        resolve([methodVersion, sanitizedAction, args]);
                    };
                    reader_1.readAsArrayBuffer(file_1);
                }
            }
        });
    };
    EmbedClient.prototype._getMethodVersion = function (action) {
        var methodsV1 = Object.values(constants_1.EmbedConstants.EMBED_METHODS);
        var methodsV2 = Object.values(constants_1.EmbedConstants.EMBED_METHODS_V2);
        if (methodsV1.includes(action)) {
            return constants_1.EmbedConstants.MessageVersions.V1;
        }
        else if (methodsV2.includes(action)) {
            return constants_1.EmbedConstants.MessageVersions.V2;
        }
        return null;
    };
    /**
     * Send message to web app to perform a given action with optional callback response
     * @param {string} action
     * @param {Interfaces.ArgsV1} parameters
     * @param {function} successCallback
     * @param {function} errorCallback
     */
    EmbedClient.prototype.performAction = function (action, parameters, successCallback, errorCallback) {
        var _this_1 = this;
        if (parameters === void 0) { parameters = {}; }
        // Input Validation
        this._validateMessageArgs(action, parameters).then(function (_a) {
            var methodVersion = _a[0], validatedAction = _a[1], validatedArgs = _a[2];
            var requestId = window.crypto.randomUUID();
            validatedArgs.requestId = requestId;
            if (methodVersion === constants_1.EmbedConstants.MessageVersions.V1) {
                _this_1.callSessionMethod(validatedAction);
                return;
            }
            // Send message AS2 Web App
            _this_1._sendMessage(validatedAction, validatedArgs, constants_1.EmbedConstants.MessageVersions.V2);
            // Response Handler
            var callbackHandler = function (event) {
                var _a;
                if (_this_1._isClientMessage(event) &&
                    event.data.method === validatedAction &&
                    ((_a = event.data.args) === null || _a === void 0 ? void 0 : _a.length) &&
                    event.data.args[0].requestId === requestId) {
                    // If received callback event for this request remove this handler
                    window.removeEventListener("message", callbackHandler);
                    // call callback
                    var args = event.data.args[0];
                    if (args.status === constants_1.EmbedConstants.ResponseStatus.SUCCESS && successCallback) {
                        successCallback(args.successResponse);
                    }
                    else if (args.status === constants_1.EmbedConstants.ResponseStatus.ERROR && errorCallback) {
                        errorCallback(args.error);
                    }
                }
            };
            if (successCallback || errorCallback) {
                window.addEventListener("message", callbackHandler);
            }
        }).catch(function (reason) {
            if (errorCallback) {
                errorCallback(reason);
            }
            else {
                var embedError = {
                    errorCode: 400,
                    errorMessage: reason ? reason : constants_1.EmbedConstants.ErrorMessages.INVALID_ACTION
                };
                _this_1.reportError(embedError);
            }
        });
    };
    /**
     * Verifies if a message is from the expected source and within the namespace. In the case of IE11
     * we avoid the message.source call due to IE throwing a script error
     * @param message
     */
    EmbedClient.prototype._isClientMessage = function (message) {
        if (!this._iframe) {
            return false;
        }
        if (this._isIE_or_Edge()) {
            return (Boolean(message.data) && message.data.namespace === constants_1.EmbedConstants.BRIDGE_CLIENT_NAMESPACE);
        }
        else {
            return (Boolean(message.data) && message.data.namespace === constants_1.EmbedConstants.BRIDGE_CLIENT_NAMESPACE &&
                message.source === this._client);
        }
    };
    EmbedClient.prototype.addEventListener = function (name, callback) {
        Object.values = Object.values || (function (obj) { return Object.keys(obj).map(function (key) { return obj[key]; }); });
        if (Object.values(constants_1.EmbedConstants.Events).indexOf(name) >= 0) {
            this._eventEmitter.on(name, callback);
        }
    };
    ;
    EmbedClient.prototype.removeEventListener = function (name, callback) {
        this._eventEmitter.removeListener(name, callback);
    };
    ;
    /**
     * Message handler
     * @param {*} event
     */
    EmbedClient.prototype.handleEvent = function (event) {
        if (event.data.version) {
            switch (event.data.version) {
                case constants_1.EmbedConstants.MessageVersions.V1:
                    this._handleEventV1(event);
                    break;
            }
        }
        else {
        }
    };
    /**
     * Handler for Message V1
     * @param {*} event
     */
    EmbedClient.prototype._handleEventV1 = function (event) {
        //Check if client message
        if (!this._isClientMessage(event)) {
            return;
        }
        var argsV1 = event.data.args[0];
        switch (event.data.method) {
            case constants_1.EmbedConstants.METHOD_UPDATE_USER_INTERFACE_STATE:
                this.updateUserInterfaceState(argsV1.userInterfaceState);
                break;
            case constants_1.EmbedConstants.METHOD_UPDATE_SESSION_STATE:
                this.updateSessionState(argsV1.sessionState);
                break;
            case constants_1.EmbedConstants.METHOD_UPDATE_SPINNER_STATE:
                this.updateSpinnerState(argsV1.spinnerEvent);
            case constants_1.EmbedConstants.METHOD_COPY_FROM_REMOTE:
                this.copyFromRemote(argsV1.clipboardText);
                break;
            case constants_1.EmbedConstants.METHOD_REPORT_ERROR:
                this.reportError(argsV1.error);
                break;
            case constants_1.EmbedConstants.METHOD_FILE_UPLOAD_PROGRESS:
                this._eventEmitter.emit(constants_1.EmbedConstants.Events.EVENT_FILE_UPLOAD_PROGRESS, argsV1.fileEvent);
                break;
            case constants_1.EmbedConstants.METHOD_FILE_DOWNLOAD_READY:
                this.handleDownloadFileEvent(argsV1.fileEvent);
                break;
            case constants_1.EmbedConstants.METHOD_SESSION_METRICS:
                this._eventEmitter.emit(constants_1.EmbedConstants.Events.EVENT_SESSION_METRICS, argsV1.sessionMetrics);
                break;
        }
    };
    EmbedClient.prototype._urlOrigin = function (url) {
        var a = document.createElement('a');
        a.href = url;
        if (a.origin !== undefined && a.origin !== null && a.origin.length > 0) {
            return a.origin;
        }
        // Needed for Edge: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12236493/
        if (a.host !== undefined && a.host !== null && a.host.length > 0) {
            return "https://" + a.host;
        }
        if (a.hostname !== undefined && a.hostname !== null && a.hostname.length > 0) {
            return "https://" + a.hostname;
        }
        return "*";
    };
    EmbedClient.prototype.enterFullscreen = function () {
        if (this.isInFullscreen()) {
            return;
        }
        else if (!this._isBridgeReady) {
            console.error("Connection Bridge is not ready yet.");
            this.reportError({
                errorCode: 400,
                errorMessage: constants_1.EmbedConstants.ErrorMessages.BRIDGE_NOT_READY
            });
            return;
        }
        this.callSessionMethod(constants_1.EmbedConstants.METHOD_ENTER_FULLSCREEN);
        var _document = window.document;
        if (_document.requestFullscreen) {
            _document.requestFullscreen();
        }
        else if (_document.webkitRequestFullscreen) {
            _document.webkitRequestFullscreen();
        }
        else if (_document.mozRequestFullScreen) {
            _document.mozRequestFullScreen();
        }
        else if (_document.msRequestFullscreen) {
            _document.msRequestFullscreen();
        }
    };
    EmbedClient.prototype.exitFullscreen = function () {
        if (!this.isInFullscreen()) {
            return;
        }
        var _document = window.document;
        if (_document.exitFullscreen) { // Standard
            _document.exitFullscreen();
        }
        else if (_document.msExitFullscreen) { // IE
            _document.msExitFullscreen();
        }
        else if (_document.mozCancelFullScreen) { // Firefox
            _document.mozCancelFullScreen();
        }
        else if (_document.webkitCancelFullScreen) { // Chrome
            _document.webkitCancelFullScreen();
        }
    };
    EmbedClient.prototype.isInFullscreen = function () {
        var _document = window.document;
        return Boolean(_document.fullscreenElement || // HTML5 standard
            _document.msFullscreenElement || // IE
            _document.mozFullScreenElement || // Firefox prefixed
            _document.mozFullScreen || // Firefox other property
            _document.webkitIsFullScreen // Chrome prefixed
        );
    };
    EmbedClient.prototype.addFullscreenEventListeners = function () {
        var _this = this;
        var fullscreenEventHandler = function () {
            if (!_this.isInFullscreen()) {
                // On exiting fullscreen, update appstream client UI
                _this.callSessionMethod(constants_1.EmbedConstants.METHOD_EXIT_FULLSCREEN);
            }
        };
        /* Standard syntax */
        document.addEventListener("fullscreenchange", fullscreenEventHandler);
        /* Firefox */
        document.addEventListener("mozfullscreenchange", fullscreenEventHandler);
        /* Chrome, Safari and Opera */
        document.addEventListener("webkitfullscreenchange", fullscreenEventHandler);
        /* IE / Edge */
        document.addEventListener("msfullscreenchange", fullscreenEventHandler);
    };
    return EmbedClient;
}());
exports.EmbedClient = EmbedClient;
